export type PresentationCompletionProps = {
  completed: boolean;
  /** The owning student can toggle it; the teacher only sees it. */
  onToggle?: () => void;
  pending?: boolean;
};

/**
 * The one 완료 check of a presentation canvas, at the right edge where the
 * class canvases keep theirs and styled the same (it reuses the strip's
 * classes). It records "I am done"; it never locks editing.
 */
export const PresentationCompletion = ({
  completed,
  onToggle,
  pending = false,
}: PresentationCompletionProps) => (
  <div
    className="canvaschool-completion-panel"
    onPointerDown={(event) => event.stopPropagation()}
  >
    <div className="canvaschool-completion-panel-title">완료표시</div>
    <div
      className="canvaschool-completion canvaschool-completion--single"
      role="group"
      aria-label="완료 표시"
    >
      {onToggle ? (
        <button
          type="button"
          aria-pressed={completed}
          aria-label={completed ? "완료 취소" : "완료"}
          disabled={pending}
          className={
            completed
              ? "canvaschool-completion-slot canvaschool-completion-slot--done"
              : "canvaschool-completion-slot"
          }
          onPointerDown={(event) => event.stopPropagation()}
          onClick={(event) => {
            event.stopPropagation();
            onToggle();
          }}
        >
          완료
        </button>
      ) : (
        <span
          role="status"
          aria-label={
            completed ? "학생이 완료했어요" : "아직 완료하지 않았어요"
          }
          className={
            completed
              ? "canvaschool-completion-slot canvaschool-completion-slot--done"
              : "canvaschool-completion-slot"
          }
        >
          {completed ? "완료" : "작성 중"}
        </span>
      )}
    </div>
  </div>
);
